import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class PersonnePhysiqueModification extends DivContainer {
	static className = "PersonnePhysiqueModification";
	
  	constructor() {
	    super();
	    this.content = () => html`
		<row-wrapper>
			<select-field label="Civilité *" required name="id_personne_physique_civilite">
				<option-component label="Choisir" value="0"></option-component>
				<option-component label="Madame" value="2"></option-component>
				<option-component label="Monsieur" value="1"></option-component>
			</select-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Prénom *" required name="first_name"></text-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Nom *" required name="last_name"></text-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Adresse *" required name="address"></text-field>
		</row-wrapper>
		<autocomplete-ville></autocomplete-ville>
		<row-with-tooltip tooltip-text="Si personne physique, indiquer la civilité (M./Mme/Melle), le prénom et le nom. Si société, indiquer la dénomination sociale">
			<text-field label="En remplacement de *" required name="replacement"></text-field>
		</row-with-tooltip>
	    `;
	}
	
	isTransient (){
		return false;
	}
}

customElements.define ("personne-physique-modification", PersonnePhysiqueModification);
